import ChatTools from './ChatTools';

export default {
  displayNameKey: 'chat_tools',
  icon: '',
  hidden: true,
  pages: {
    ChatTools,
  },
};



// WEBPACK FOOTER //
// ./src/modules/ChatTools/index.js